import React from "react";
import { statusColor } from "helpers/commonFunctions";

/**
 * The Active / InActive pill as plain text, for users who cannot change the
 * status. Same look as the clickable toggle, without the Popconfirm.
 */
const StatusBadge = ({ active }) => (
  <span className={`${statusColor(active)} status-badge`}>
    {active ? "Active" : "InActive"}
  </span>
);

export default StatusBadge;
